/**
 * Header Dropdown Menü Optimizer
 * Vücut ve İçeriğe Göre menülerini sağa kaydırır ve dropdown yüksekliğini optimize eder
 */

document.addEventListener('DOMContentLoaded', function() {
  // Mega menu grid'ini optimize et
  optimizeMegaMenu();
  
  // Menü açıldığında da optimize et
  document.addEventListener('click', function(e) {
    if (e.target.closest('.menu-list__link--has-submenu')) {
      setTimeout(optimizeMegaMenu, 100);
    }
  });
});

function optimizeMegaMenu() {
  const megaMenuGrids = document.querySelectorAll('.mega-menu__grid');

  megaMenuGrids.forEach(grid => {
    grid.classList.add('mega-menu__grid--optimized');

    const list = grid.querySelector('.mega-menu__list');

    if (list) {
      list.classList.add('mega-menu__list--optimized');
    }
  });
}



// Menü hover olaylarını dinle
document.addEventListener('mouseenter', function(e) {
  if (e.target.closest('.menu-list__link--has-submenu')) {
    setTimeout(optimizeMegaMenu, 50);
  }
}, true);

// Sayfa yüklendiğinde ve resize olduğunda optimize et
window.addEventListener('resize', function() {
  if (window.innerWidth >= 990) {
    setTimeout(optimizeMegaMenu, 100);
  }
});


